import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * A escala tipográfica do GIYUS (`text-caption`, `text-body-sm`, `text-body`, `text-title`, `text-headline`,
 * `text-display`) são tamanhos, não cores. Sem declarar isso, o tailwind-merge as trata como cor e descarta
 * `text-primary-foreground` (e vice-versa) quando vêm juntas.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['caption', 'body-sm', 'body', 'title', 'headline', 'display'] }],
    },
  },
});

/** Combina classes condicionais e resolve conflitos de utilitários Tailwind. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
